module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-scottsville-black.45e1ffae.svg";